const perfisUsuarioComBeneficio = [1, 2];//COM_OU_SEM_BENEFICIO E COM_BENEFICIO
const perfisUsuarioSemBeneficio = [1, 3];//COM_OU_SEM_BENEFICIO E SEM_BENEFICIO

export const itemsSemBeneficioPraVoce = (servicos) => {
  const dadosOrdenados = servicos?.filter(servico => perfisUsuarioSemBeneficio.includes(servico.perfilUsuario)).slice(0, 4);
  return convertServicosToItemMenuList(dadosOrdenados)
}

export const outrosVisivelSemBeneficioPraVoce = (servicos) => {
  const dadosOrdenados = servicos?.filter(servico => perfisUsuarioSemBeneficio.includes(servico.perfilUsuario)).slice(4, 8);
  return convertServicosToItemMenuList(dadosOrdenados)
}

export const outrosInvisivelSemBeneficioPraVoce = (servicos) => {
  const dadosOrdenados = servicos?.filter(servico => perfisUsuarioSemBeneficio.includes(servico.perfilUsuario)).slice(4);
  return convertServicosToItemMenuList(dadosOrdenados)
}

export const itemsComBeneficioPraVoce = (servicos) => {
  const dadosOrdenados = servicos?.filter(servico => perfisUsuarioComBeneficio.includes(servico.perfilUsuario)).slice(0, 4);
  return convertServicosToItemMenuList(dadosOrdenados)
}

export const outrosVisivelComBeneficioPraVoce = (servicos) => {
  const dadosOrdenados = servicos?.filter(servico => perfisUsuarioComBeneficio.includes(servico.perfilUsuario)).slice(4, 8);
  return convertServicosToItemMenuList(dadosOrdenados);
}

export const outrosInvisivelComBeneficioPraVoce = (servicos) => {
  const dadosOrdenados = servicos?.filter(servico => perfisUsuarioComBeneficio.includes(servico.perfilUsuario)).slice(4);
  return convertServicosToItemMenuList(dadosOrdenados);
}


export const itemsPraVoce = (beneficios = [], servicos = []) => {
  const perfil = getPerfilVisualizacao(beneficios);
  const campo = configVisualizacaoServicos[perfil].campo;
  const servicosOrdenados = servicos?.sort((a, b) => a[campo] - b[campo]);

  const dadosOrdenados = servicosOrdenados
    ?.filter(servico => servico.perfisUsuario && servico.perfisUsuario.includes(configVisualizacaoServicos[perfil].perfil))
    .slice(0, 4);

  return convertServicosToItemMenuList(dadosOrdenados);
}

export const itemsPraVoceHome = (servicos = []) => {
  const servicosOrdenados = servicos?.sort((a, b) => a['ordem'] - b['ordem']);

  return convertServicosToItemMenuList(servicosOrdenados);
}

export const outrosVisivelPraVoce = (beneficios = [], servicos = []) => {
  const perfil = getPerfilVisualizacao(beneficios);
  const campo = configVisualizacaoServicos[perfil].campo;
  const servicosOrdenados = servicos?.sort((a, b) => a[campo] - b[campo]);

  const dadosOrdenados = servicosOrdenados?.filter(servico => servico.perfisUsuario.includes(configVisualizacaoServicos[perfil].perfil)).slice(4, 8);

  return convertServicosToItemMenuList(dadosOrdenados);
}

export const outrosInvisivelPraVoce = (beneficios = [], servicos = []) => {
  const perfil = getPerfilVisualizacao(beneficios);
  const campo = configVisualizacaoServicos[perfil].campo;
  const servicosOrdenados = servicos?.sort((a, b) => a[campo] - b[campo]);

  const dadosOrdenados = servicosOrdenados?.filter(servico => servico.perfisUsuario.includes(configVisualizacaoServicos[perfil].perfil)).slice(4);

  return convertServicosToItemMenuList(dadosOrdenados);
}

const getTags = (servico) => {
  if(servico.tags){
    if(Array.isArray(servico.tags)){
      return servico.tags;
    }else{
      return servico.tags.split(",");
    }
  }
  return []
}

export const removeBarrasIniciais = (rota) => {
  return rota ? rota.replace(/^\/+/, '') : null;
}

export const convertToItemMenu = (servico) => {
  if(!servico) return null;
  
  if (servico.tipo === "GRUPO_SERVICOS") {
    return {
      ...servico,
      menuPage: servico.titulo,
      pagePath: removeBarrasIniciais(servico.rota),
      icon: servico.icone,
      new: servico.isDestaque,
      tags: getTags(servico),
      items: servico.subItens ? convertServicosToItemMenuList(servico.subItens) : []
    }
  } else {
    if (servico.tipoServico === 1) { //INSS
      const newService = {
        ...servico,
        miService: servico.titulo,
        path: servico.rota ? `/${removeBarrasIniciais(servico.rota)}` : servico.rota,
        icon: servico.icone,
        new: servico.isDestaque,
        tags:  getTags(servico),
        manutencaoWeb: servico.manutencaoWeb,
        manutencaoMobile: servico.manutencaoMobile,
        descricaoManutencaoWeb: servico.descricaoManutencaoWeb,
        descricaoManutencaoMobile: servico.descricaoManutencaoMobile
      }
      if (servico.rota?.toLowerCase()?.includes('v35')) {
        newService.oldVersionService = servico.titulo;
        newService.path = `${servico.rota}`;
      }
      return newService
    }

    if (servico.tipoServico === 2) {//SAG
      return {
        ...servico,
        sagService: servico.titulo,
        id: servico.sigla,
        sigla: servico.sigla,
        icon: servico.icone,
        new: servico.isDestaque,
        tags: getTags(servico),
        manutencaoWeb: servico.manutencaoWeb,
        manutencaoMobile: servico.manutencaoMobile,
        descricaoManutencaoWeb: servico.descricaoManutencaoWeb,
        descricaoManutencaoMobile: servico.descricaoManutencaoMobile
      }
    }
    if (servico.tipoServico === 3) {//EXTERNO
      return {
        ...servico,
        externalLink: servico.titulo,
        url: servico.rota,
        icon: servico.icone,
        new: servico.isDestaque,
        tags: getTags(servico),
        manutencaoWeb: servico.manutencaoWeb,
        manutencaoMobile: servico.manutencaoMobile,
        descricaoManutencaoWeb: servico.descricaoManutencaoWeb,
        descricaoManutencaoMobile: servico.descricaoManutencaoMobile
      }
    }
  }

}

export const convertServicosToItemMenuList = (dados) => {
  
  
  if (dados === null || dados === undefined || typeof dados === 'string') {
    return [];
  }

  return dados?.map(servico => convertToItemMenu(servico))

}


export const getPerfilVisualizacao = (beneficios = []) => {

  let perfil = 'SEM_BENEFICIO';

  if (beneficios?.length > 0 && beneficios !== 'erro') {
    const SITUACOES_BENEFICIOS = beneficios?.map(bene => bene.situacao);

    if (SITUACOES_BENEFICIOS?.includes('ATIVO')) {
      perfil = 'COM_BENEFICIO_ATIVO'
    } else {
      perfil = 'COM_BENEFICIO_NAO_ATIVO'
    }

  }

  return perfil;
}

export const configVisualizacaoServicos = {

  COM_BENEFICIO_ATIVO: {
    campo: 'ordemComBeneficio',
    perfil: 2
  },
  COM_BENEFICIO_NAO_ATIVO: {
    campo: 'ordemComBeneficioNaoAtivo',
    perfil: 4
  },
  SEM_BENEFICIO: {
    campo: 'ordemSemBeneficio',
    perfil: 3

  }
}

export function removeServicoIndisponiveisDoMenu(items, regra) {
  return items
    .filter(item => item.tipo === "GRUPO_SERVICOS" || item[regra] !== false)
    .map(item => {
      if (item.subItens && Array.isArray(item.subItens)) {
        return {
          ...item,
          subItens: removeServicoIndisponiveisDoMenu(item.subItens, regra)
        };
      }
      return item;
    });
}

